<template>
	<div class="banner_sub">
		<div class="banner_content">
			<router-link v-if="headerStore.getCountry === 'USA'" to="/notice-detail/166" class="logo">
				<img src="@/assets/img/common/banner_sub_usa.jpg" class="banner_content_img" loading="lazy" alt="banner" />
			</router-link>
			<router-link v-else-if="headerStore.getCountry === 'JPN'" to="/notice-detail/199" class="logo">
				<img src="@/assets/img/common/banner_sub_jpn.jpg" class="banner_content_img" loading="lazy" alt="banner" />
			</router-link>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useHeaderStore } from '@/stores/header';

const headerStore = useHeaderStore();
</script>
<style lang="scss" scoped>
.banner_sub {
	position: relative;
	overflow: hidden;
	border-radius: 0.8rem;
	.banner_content {
		display: flex;
		width: 100%;
		&_img {
			object-fit: contain;
			width: 100%;
			height: 100%;
		}
	}
}
</style>
